import React, { useEffect, useState, useRef } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

// INFO - lightgreen, WARNING - khaki, ERROR - salmon, Activado - green, UP - green,, default - gray

export function HubSectionDialog(props) {
  const { openHubSectionDialog, setOpenHubSectionDialog, titleRef, textRef, videoRef, videoTutorialRef, linkRef } = props;
  const { t } = useTranslation("global")

    

  const handleClose = () => {
    setOpenHubSectionDialog(false);

  };

  const handleClickOpenURL = (url) => () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Dialog disableRestoreFocus={true} className='sig_Drawer_SettingsModal_Root sig_Server_SettingsModal_Root' open={openHubSectionDialog} onClose={handleClose}>
        <DialogTitle className='sig_Drawer_SettingsModal_Title sig_Hub_InfoModal_Title' > {titleRef} </DialogTitle>
        <DialogContent className='sig_Drawer_SettingsModal_Content sig_Server_Root'>

            <div className="sig_Hub_InfoModal">
                <div className="sig_Hub_CardVideo">
                    <video autoPlay loop muted src={videoRef}/>
                </div>
                <div className="sig_Hub_CardText">
                    <p>{textRef}</p>
                </div>

                {videoTutorialRef !== "" ?
                  <>
                  <Button className="sig_Hub_Card_ButtonModal" onClick={handleClickOpenURL(videoTutorialRef)}>
                    {t("sHub.video_demostration").toUpperCase()}
                  </Button>
                  </>:
                  <></>
                }

                
                <br></br>
                <Link className="sig_Hub_Card_ButtonModal" to={linkRef}>
                  {t("strButton.btn_access").toUpperCase()}
                </Link>
            </div>

            <DialogActions className="sig_FormDialog_Button">
                <Button onClick={handleClose}> {t("strButton.btn_exit")} </Button>
            </DialogActions>

        </DialogContent>
    </Dialog>
  );
}